/**
 * Manage the document scroll
 */
const ScrollManager = {
    /**
     * Incremented by the preventScroll() method
     * Page scroll locked when the value is greater than 0
     */
    preventScrollCounter: 0,
    
    /**
     * Lock/unlock the page scroll
     * 
     * @param {boolean} state true = locked / false = unlocked
     * 
     * @return {ScrollManager}
     */
    preventScroll(state: boolean) : typeof ScrollManager {
        if (state) {
            this.preventScrollCounter++;
        } else if (this.preventScrollCounter > 0) {
            this.preventScrollCounter--;
        }

        // Toggle the class "prevent-scroll" on body element if the counter is greater than 0
        document.body.classList.toggle('prevent-scroll', this.preventScrollCounter > 0);

        return this;
    },

    /**
     * Scroll to an offset or an element
     * 
     * @param {HTMLElement|number} $element 
     * @param {boolean} smooth (default: true)
     * 
     * @return {ScrollManager}
     */
    scrollTo($element: HTMLElement|number, smooth = true) : typeof ScrollManager {
        const posY = typeof $element === 'number' ? $element : $element.getBoundingClientRect().top + window.scrollY;

        if (!smooth) {
            // Remove the scrollBehavior
            document.documentElement.style.scrollBehavior = 'initial';
            document.body.style.scrollBehavior = 'initial';
        }

        window.scroll(0, posY);

        if (!smooth) {
            // Reset the scrollBehavior
            document.documentElement.style.scrollBehavior = '';
            document.body.style.scrollBehavior = '';
        }

        return this;
    },
};

export default ScrollManager;
